import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import {Box, Button, Text, useTheme} from '@spothero/ui';

import {
    eventListItemStyleProps,
    eventListItemTitleStyleProps,
    eventListItemBottomStyleProps,
    EventListItemButtonStyleProps,
    eventListItemDateDayStyleProps,
    eventListItemDetailsStyleProps,
    eventListItemDateMonthStyleProps,
    eventListItemDateContainerStyleProps,
} from './EventListStyleProps';

const EventListItem = ({event, trackingLink, openNewTabOnClick}) => {
    const {title, starts, id} = event;
    const startsMoment = moment(starts);
    const {
        partnerWidgetStyles: {eventListStyles: customEventListStyles},
    } = useTheme();

    const startsDateFormat = startsMoment.isSame(moment(), 'day')
        ? '[Today]'
        : `ddd, MMM D YYYY`;

    const eventSearchUrl = `${trackingLink}&kind=event&id=${id}`;
    const buttonTarget = openNewTabOnClick ? 'blank' : '_parent';

    return (
        <Box
            {...eventListItemStyleProps}
            {...customEventListStyles.eventListItem}
            data-testid="EventListItem"
        >
            <Box
                {...eventListItemDetailsStyleProps}
                {...customEventListStyles.eventListItemDetails}
            >
                <Box
                    {...eventListItemDateContainerStyleProps}
                    {...customEventListStyles.eventListItemDate.dateContainer}
                >
                    <Box
                        {...eventListItemDateMonthStyleProps}
                        {...customEventListStyles.eventListItemDate.month}
                    >
                        {startsMoment.format('MMM')}
                    </Box>
                    <Box
                        {...eventListItemDateDayStyleProps}
                        {...customEventListStyles.eventListItemDate.day}
                    >
                        {startsMoment.format('DD')}
                    </Box>
                </Box>
                <Box {...customEventListStyles.eventListItemText.textContainer}>
                    <Text
                        itemProp="name"
                        {...eventListItemTitleStyleProps}
                        {...customEventListStyles.eventListItemText.title}
                    >
                        {title}
                    </Text>
                    <Text
                        {...eventListItemBottomStyleProps}
                        {...customEventListStyles.eventListItemText.bottom}
                    >
                        {startsMoment.format(`${startsDateFormat} [at] h:mm A`)}
                    </Text>
                </Box>
            </Box>
            <Button
                as="a"
                href={eventSearchUrl}
                target={buttonTarget}
                aria-label="Find Parking"
                {...EventListItemButtonStyleProps}
            >
                Find Parking
            </Button>
        </Box>
    );
};

EventListItem.propTypes = {
    event: PropTypes.shape({
        title: PropTypes.string,
        starts: PropTypes.string,
        id: PropTypes.number,
    }),
    trackingLink: PropTypes.string,
    openNewTabOnClick: PropTypes.bool,
};

export default EventListItem;
